import React from "react";
import { AUDITS } from "../../core/theme/auditsTheme";
import AuditsSidePanel from "./components/AuditsSidePanel";
import SnapshotsList from "./components/SnapshotsList";
import useWebsiteSearch from "./useWebsiteSearch";

// The Audits page: full page, two columns. Left: Your area and What you have
// (placeholders until later stages). Right: every snapshot, grouped by niche,
// searchable by name, tag or advertiser website.
export default function JobsScreen({ agencyId, jobs, jobsLoading, jobSearch, setJobSearch, onOpenJob, onOpenPinned, onStopJob, onNewScan }) {
  const website = useWebsiteSearch(agencyId, jobSearch);

  return (
    <div className={AUDITS.page}>
      <AuditsSidePanel />
      <SnapshotsList
        jobs={jobs} jobsLoading={jobsLoading} jobSearch={jobSearch} setJobSearch={setJobSearch} website={website}
        onOpenJob={onOpenJob} onOpenPinned={onOpenPinned} onStopJob={onStopJob} onNewScan={onNewScan}
      />
    </div>
  );
}
